function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Brick from "./brick";
import AppEvent from "zengular/src/app-event";
/**
 * @property {Object<string, typeof Brick>} registry
 * @property {MutationObserver} domObserver
 */

var BrickRegistry = /*#__PURE__*/function () {
  function BrickRegistry() {
    var _this = this;

    _classCallCheck(this, BrickRegistry);

    this.domObserver = new MutationObserver(function (mutationsList) {
      mutationsList.forEach(function (mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length) _this.initializeElements();
      });
    });
    this.registry = {};
  }
  /**
   * @param {typeof Brick} target
   */


  _createClass(BrickRegistry, [{
    key: "register",
    value: function register(target) {
      this.registry[target.tag] = target;
    }
    /**
     * @param {string} tag
     * @returns {Brick | undefined}
     */

  }, {
    key: "getBrick",
    value: function getBrick(tag) {
      return this.registry[tag];
    }
    /**
     * @param {HTMLElement} root
     */

  }, {
    key: "initialize",
    value: function initialize() {
      var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      this.domObserver.observe(root, {
        attributes: false,
        childList: true,
        subtree: true
      });
      return this.initializeElements();
    }
    /**
     * @param {HTMLElement} scope
     */

  }, {
    key: "initializeElements",
    value: function initializeElements() {
      var _this2 = this;

      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      var renderQueue = [];
      scope.querySelectorAll('[is]:not([brick-initialized])').forEach(function (element) {
        var tag = element.getAttribute('is');
        var typeofBrick = _this2.registry[tag];

        if (typeofBrick) {
          var brick = new typeofBrick(element, false);
          if (typeofBrick.options.renderOnConstruct) renderQueue.push(brick.render());
        } else console.warn("".concat(tag, " brick was mentioned, but is not defined"));
      });
      return Promise.all(renderQueue);
    }
  }]);

  return BrickRegistry;
}();

var registry = new BrickRegistry();
export default registry;